import { AuthError, defineView } from '@juvare/platform-app/App';
import { allowViewLicenseStatus } from '../../permissions';
import { licenseCheckLatestStatusListViewColumns, } from '../entities/licenseCheckLatestStatusViewTypes';
const viewQuery = `
SELECT
    lcls._id as id,
    lcls.person_id as person_id,
    lcls.occupation_id as occupation_id,
    lcls.credential_id as credential_id,
    lcls.jas_board as jas_board,
    lcls.license_id as license_id,
    lcls.status as status,
    lcls.person_name as person_name,
    lcls.occupation_name as occupation_name,
    lcls.request_date as request_date,
    lcls.requested_by as requested_by,
    lcls.credential_name as credential_name,
    lcls.search as search,
    o.group_id as occupation_group_id,
    a.city as city,
    a.state as state,
    a.county as county,
    a.tribe_id as tribe_id,
    a.ecls as ecls,
    a.system_status as person_system_status,
    t.name as tribe
FROM
    license_check_latest_status_cache lcls
        LEFT JOIN account_cache a ON lcls.person_id = a._id
        LEFT JOIN occupation_cache o ON lcls.occupation_id::uuid = o._id
        LEFT JOIN tribe_cache t ON a.tribe_id::uuid = t._id
`;
export const licenseCheckLatestStatusListView = defineView({
    columns: licenseCheckLatestStatusListViewColumns,
    viewQuery,
    orderByColumn: 'requestDate',
    orderByDesc: true,
    onAuthList: (appState, userState, response) => {
        for (const row of response.rows) {
            if (!allowViewLicenseStatus(userState, row.personId)) {
                throw new AuthError('Unauthorized, user cannot view license status');
            }
        }
        return response;
    },
});
